export default "__VITE_ASSET__BPKdoV8k__"